(function ($) {
  Drupal.behaviors.socialShareV1 = {
    attach: function (context) {
      var $socialShareContainer = $('.js-blog-social-share', context);
      var url = window.location.href.split('#')[0];
      var title = document.title;
      var imagePath = $('.js-blog-social-share-image', $socialShareContainer)
        .find('img')
        .data('src');
      var $shareText = $('.js-blog-social-share-text', $socialShareContainer);

      title = $shareText.length > 0 ? $shareText.text() : title;

      var twitterURL = $socialShareContainer.find('.js-blog-social-icon .twitter a').attr('href');
      var facebookURL = $socialShareContainer.find('.js-blog-social-icon .facebook a').attr('href');
      var pinterestURL = $socialShareContainer
        .find('.js-blog-social-icon .pinterest a')
        .attr('href');
      var whatsappURL = $socialShareContainer.find('.js-blog-social-icon .whatsapp a').attr('href');
      var weiboURL = $socialShareContainer.find('.js-blog-social-icon .weibo a').attr('href');
      var emailURL = $socialShareContainer.find('.js-blog-social-icon .email a').attr('href');

      twitterURL = twitterURL + encodeURI(url) + '&amp;text=' + encodeURI(title);
      facebookURL = facebookURL + encodeURI(url) + '&quote=' + title;
      pinterestURL =
        pinterestURL +
        encodeURI(url) +
        '&amp;media=' +
        encodeURI(window.location.protocol) +
        '//' +
        encodeURI(window.location.host) +
        imagePath +
        '&amp;description=' +
        title;
      whatsappURL = whatsappURL + title + '&quote=' + encodeURI(url);
      weiboURL = weiboURL + encodeURI(url) + '&amp;t=' + encodeURI(title);
      emailURL = emailURL + encodeURI(url) + '&subject=' + encodeURI(title);
      $socialShareContainer.prev().addClass('blog-social-share-postion');

      $socialShareContainer.find('.js-blog-social-icon .twitter a').attr('href', twitterURL);
      $socialShareContainer.find('.js-blog-social-icon .facebook a').attr('href', facebookURL);
      $socialShareContainer.find('.js-blog-social-icon .pinterest a').attr('href', pinterestURL);
      $socialShareContainer.find('.js-blog-social-icon .whatsapp a').attr('href', whatsappURL);
      $socialShareContainer.find('.js-blog-social-icon .email a').attr('href', emailURL);
      $socialShareContainer.find('.js-blog-social-icon .weibo a').attr('href', weiboURL);

      /* Social share links */
      $('.js-blog-social-share-link', context)
        .once()
        .on('click', function (e) {
          if (!e) {
            e = window.event;
          }
          e.cancelBubble = true;
          if (e.stopPropagation) {
            e.stopPropagation();
          }

          var $this = $(this);
          var $socialBlog = $this.parents('.js-blog-social-icon');
          var width = $socialBlog.data('width') ? $socialBlog.data('width') : 600;
          var height = $socialBlog.data('height') ? $socialBlog.data('height') : 350;
          var openUrl = $this.attr('href');
          // Allow for borders.
          var leftPosition = window.screen.width / 2 - (width / 2 + 10);
          // Allow for title and status bars.
          var topPosition = window.screen.height / 2 - (height / 2 + 50);
          var windowFeatures = 'status=no,height=' + height + ',width=' + width;

          windowFeatures += ',resizable=yes,left=' + leftPosition + ',top=' + topPosition;
          windowFeatures += ',screenX=' + leftPosition + ',screenY=' + topPosition;
          windowFeatures += ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no';

          if ($(this).parent().hasClass('mail')) {
            window.location.href = openUrl;
          } else {
            window.open(openUrl, 'sharer', windowFeatures);
          }
          e.preventDefault();
        });
      $(document).ready(function () {
        $(window)
          .off('scroll')
          .on(
            'scroll',
            _.debounce(function () {
              var $socialIcon = $socialShareContainer.find('.js-blog-social-icon');
              var socialSharePostion = $socialShareContainer.position().top + $socialIcon.height();
              if ($(window).scrollTop() > socialSharePostion) {
                $socialIcon.addClass('blog-social-icon-fixed');
              } else {
                $socialIcon.removeClass('blog-social-icon-fixed');
              }
            }, 100)
          );
      });
    }
  };
})(jQuery);
